/**
 * 配置文件
 * @author huazai
 */
const config = {
  copyright: "Copyright@2020",
  icp_number: "黔ICP备16009911号-5",
  address: "贵阳市南明区宝山南路27号东山大厦1005",
  e_mail: "gzcept@qq.com",
  tel: "0851-85584260",
  t_support: "贵州省水利水电勘测设计研究院股份有限公司",
  tel_support: "0851-85584833",
  icp_url: "https://beian.miit.gov.cn",
  try_time: 120, //试看时长2分钟，120秒
  cert_title: "专业技术人员继续教育",
  partner_code: "chutou-tech",
  temp_user_list: [
    "2c9c8594971a1f370197633abce60504",
    "828080818eeebdd3018eeebdd545068f",
    "828080818eeebdd3018eeebdd42500ce",
    "2c9c8594971a1f370197633abce10502",
    "828080818eeebdd3018eeebdd545065f",
    "828080818eeebdd3018eeebdd545069e",
    "828080818eeebdd3018eeebdd545068a",
    "2c9c8594971a1f370197633abd750524",
    "828080818eeebdd3018eeebdd52405ba",
    "828080818eeebdd3018eeebdd545066c",
    "828080818eeebdd3018eeebdd5450641",
    "828080818eeebdd3018eeebdd5240598",
    "828080818eeebdd3018eeebdd5240628",
    "828080818eeebdd3018eeebdd5450672",
    "828080818eeebdd3018eeebdd524063b",
    "2c9c8594971a1f370197633abe5e0556",
    "828080818eeebdd3018eeebdd5450683",
    "828080818eeebdd3018eeebdd5240593",
    "828080818eeebdd3018eeebdd5240590",
    "828080818eeebdd3018eeebdd5240599",
    "2c9c8594971a1f370197633abec10572",
    "828080818eeebdd3018eeebdd52405a8",
    "828080818eeebdd3018eeebdd52405ae",
    "2c9c8594971a1f370197633abee40580",
    "828080818eeebdd3018eeebdd52405ab",
    "2c9c8594971a1f370197633abedf057e",
    "2c9c8594971a1f370197633abefb0588",
    "2c9c8594971a1f370197633abe72055e",
    "828080818eeebdd3018eeebdd52405d0",
    "828080818eeebdd3018eeebdd524060b",
    "2c9c8594971a1f370197633abdaa0532",
    "2c9c8594971a1f370197633abe34054a",
    "828080818eeebdd3018eeebdd5240602",
    "828080818eeebdd3018eeebdd54506c8",
    "828080818eeebdd3018eeebdd54506a8",
    "828080818eeebdd3018eeebdd4260185",
    "828080818eeebdd3018eeebdd54506a1",
    "828080818eeebdd3018eeebdd42500e1",
    "828080818eeebdd3018eeebdd5240604",
    "828080818eeebdd3018eeebdd52405d1",
    "828080818eeebdd3018eeebdd425011d",
    "828080818eeebdd3018eeebdd5240586",
    "828080818eeebdd3018eeebdd524058e",
    "828080818eeebdd3018eeebdd5240635",
    "828080818eeebdd3018eeebdd5450668",
    "828080818eeebdd3018eeebdd52405cf",
    "2c9c8594971a1f370197633abe95056c",
    "2c9c8594971a1f370197633abf0d058e",
    "2c9c8594971a1f370197633abf09058c",
    "828080818eeebdd3018eeebdd56607be",
    "2c9c8594971a1f370197633abf4c05a2",
    "828080818eeebdd3018eeebdd545067c",
    "828080818eeebdd3018eeebdd4260171",
    "2c9c8594971a1f370197633abd860528",
    "828080818eeebdd3018eeebdd42500e0",
    "828080818eeebdd3018eeebdd5240639",
    "2c9c8594971a1f370197633abc5e04da",
    "828080818eeebdd3018eeebdd5240581",
    "828080818eeebdd3018eeebdd52405e5",
    "828080818eeebdd3018eeebdd42500fb",
    "828080818eeebdd3018eeebdd524058f",
    "828080818eeebdd3018eeebdd5450640",
    "2c9c8594971a1f370197633abec50574",
    "2c9c8594971a1f370197633abf6f05ac",
    "828080818eeebdd3018eeebdd52405e8",
    "828080818eeebdd3018eeebdd52405e1",
    "2c9c8594971a1f370197633abd45051c",
    "828080818eeebdd3018eeebdd524058b",
    "828080818eeebdd3018eeebdd54506a4",
    "828080818eeebdd3018eeebdd5240580",
    "828080818eeebdd3018eeebdd52405ca",
    "2c9c8594971a1f370197633abf4705a0",
    "828080818eeebdd3018eeebdd545067d",
    "828080818eeebdd3018eeebdd52405d4",
    "828080818eeebdd3018eeebdd5240619",
    "828080818eeebdd3018eeebdd5240633",
    "828080818eeebdd3018eeebdd4260186",
    "2c9c8594971a1f370197633abef00584",
    "828080818eeebdd3018eeebdd54506c3",
    "2c9c8594971a1f370197633abbf804be",
    "828080818eeebdd3018eeebdd42500d8",
    "828080818eeebdd3018eeebdd52405b6",
    "828080818eeebdd3018eeebdd52405f6",
    "828080818eeebdd3018eeebdd52405c3",
    "828080818eeebdd3018eeebdd52405cd",
    "828080818eeebdd3018eeebdd54506b6",
    "828080818eeebdd3018eeebdd52405a2",
    "2c9c8594971a1f370197633abcf30508",
    "828080818eeebdd3018eeebdd42500e3",
    "828080818eeebdd3018eeebdd42500db",
    "2c9c8594971a1f370197633abe8a0568",
    "828080818eeebdd3018eeebdd5450654",
    "828080818eeebdd3018eeebdd524059c",
    "828080818eeebdd3018eeebdd42500cc",
    "828080818eeebdd3018eeebdd524057d",
    "828080818eeebdd3018eeebdd54506bc",
    "828080818eeebdd3018eeebdd5240614",
    "2c9c8594971a1f370197633abda30530",
    "828080818eeebdd3018eeebdd524057e",
    "828080818eeebdd3018eeebdd524057b",
    "828080818eeebdd3018eeebdd52405e6",
    "828080818eeebdd3018eeebdd52405b2",
    "2c9c8594971a1f370197633abf5905a6",
    "828080818eeebdd3018eeebdd545064b",
    "828080818eeebdd3018eeebdd52405d5",
    "2c9c8594971a1f370197633abe100544",
    "828080818eeebdd3018eeebdd52405b8",
    "828080818eeebdd3018eeebdd5240636",
    "828080818eeebdd3018eeebdd52405f2",
    "828080818eeebdd3018eeebdd42500e4",
    "828080818eeebdd3018eeebdd52405a6",
    "2c9c8594971a1f370197633abe67055a",
    "828080818eeebdd3018eeebdd545068c",
    "828080818eeebdd3018eeebdd524062a",
    "828080818eeebdd3018eeebdd4260136",
    "828080818eeebdd3018eeebdd52405bf",
    "828080818eeebdd3018eeebdd5450653",
    "2c9c8594971a1f370197633abef60586",
    "828080818eeebdd3018eeebdd524058d",
    "2c9c8594971a1f370197633abd50051e",
    "828080818eeebdd3018eeebdd4260138",
    "2c9c8594971a1f370197633abdb40536",
    "828080818eeebdd3018eeebdd504054d",
    "828080818eeebdd3018eeebdd5450659",
    "828080818eeebdd3018eeebdd545069f",
    "828080818eeebdd3018eeebdd52405be",
    "828080818eeebdd3018eeebdd524063d",
    "828080818eeebdd3018eeebdd42500ca",
    "828080818eeebdd3018eeebdd5240587",
    "828080818eeebdd3018eeebdd5240629",
    "828080818eeebdd3018eeebdd5450690",
    "828080818eeebdd3018eeebdd524059f",
    "828080818eeebdd3018eeebdd52405ea",
    "828080818eeebdd3018eeebdd524057c",
    "2c9c8594971a1f370197633abc6804de",
    "828080818eeebdd3018eeebdd524057a",
    "828080818eeebdd3018eeebdd426015d",
    "2c9c8594971a1f370197633abe840566",
    "828080818eeebdd3018eeebdd524060f",
    "2c9c8594971a1f370197633abf00058a",
    "828080818eeebdd3018eeebdd52405b0",
    "828080818eeebdd3018eeebdd524061a",
    "828080818eeebdd3018eeebdd52405a5",
    "828080818eeebdd3018eeebdd42500fa",
    "2c9c8594971a1f370197633abcec0506",
    "828080818eeebdd3018eeebdd52405c7",
    "828080818eeebdd3018eeebdd52405d7",
    "828080818eeebdd3018eeebdd524059e",
    "828080818eeebdd3018eeebdd52405c1",
    "828080818eeebdd3018eeebdd5240588",
    "828080818eeebdd3018eeebdd52405c8",
    "828080818eeebdd3018eeebdd3cb00c7",
    "828080818eeebdd3018eeebdd5240623",
    "2c9c8594971a1f370197633abc3204ce",
    "2c9c8594971a1f370197633abf5d05a8",
    "828080818eeebdd3018eeebdd52405ff",
    "2c9c8594971a1f370197633abc8404e4",
    "828080818eeebdd3018eeebdd4260153",
    "828080818eeebdd3018eeebdd52405e3",
    "828080818eeebdd3018eeebdd5240589",
    "828080818eeebdd3018eeebdd426012f",
    "2c9c8594971a1f370197633abdfd053c",
    "2c9c8594971a1f370197633abd310514",
    "2c9c8594971a1f370197633abe02053e",
    "828080818eeebdd3018eeebdd5450687",
    "2c9c8594971a1f370197633abe150546",
    "2c9c8594971a1f370197633abe060540",
    "2c9c8594971a1f370197633abece0578",
    "828080818eeebdd3018eeebdd524058a",
    "2c9c8594971a1f370197633abc9e04ec",
    "828080818eeebdd3018eeebdd545068d",
    "828080818eeebdd3018eeebdd5450648",
    "2c9c8594971a1f370197633abe8f056a",
    "828080818eeebdd3018eeebdd5240632",
    "2c9c8594971a1f370197633abc8d04e6",
    "828080818eeebdd3018eeebdd5240579",
    "828080818eeebdd3018eeebdd52405ac",
    "2c9c8594971a1f370197633abd18050e",
    "2c9c8594971a1f370197633abcc004f8",
    "2c9c8594971a1f370197633abc4804d4",
    "2c9c8594971a1f370197633abe39054c",
    "828080818eeebdd3018eeebdd524059b",
    "828080818eeebdd3018eeebdd52405f4",
    "2c9c8594971a1f370197633abc9904ea",
    "828080818eeebdd3018eeebdd52405d3",
    "2c9c8594971a1f370197633abd1f0510",
    "2c9c8594971a1f370197633abd3b0518",
    "828080818eeebdd3018eeebdd4260180",
    "828080818eeebdd3018eeebdd5450694",
    "828080818eeebdd3018eeebdd52405f8",
    "2c9c8594971a1f370197633abdba0538",
    "828080818eeebdd3018eeebdd524063e",
    "2c9c8594971a1f370197633abca904f0",
    "2c9c8594971a1f370197633abd01050a",
    "2c9c8594971a1f370197633abeda057c",
    "828080818eeebdd3018eeebdd524063f",
    "2c9c8594971a1f370197633abd92052c",
    "828080818eeebdd3018eeebdd42500f3",
    "2c9c8594971a1f370197633abd360516",
    "828080818eeebdd3018eeebdd545068b",
    "2c9c8594971a1f370197633abf38059a",
    "828080818eeebdd3018eeebdd5240592",
    "828080818eeebdd3018eeebdd52405af",
    "2c9c8594971a1f370197633abf41059e",
    "2c9c8594971a1f370197633abe500550",
    "2c9c8594971a1f370197633abe800564",
    "2c9c8594971a1f370197633abc1c04c6",
    "2c9c8594971a1f370197633abc4204d2",
    "828080818eeebdd3018eeebdd52405ce",
    "2c9c8594971a1f370197633abc2804ca",
    "828080818eeebdd3018eeebdd52405e2",
    "2c9c8594971a1f370197633abc7704e0",
    "2c9c8594971a1f370197633abf1e0592",
    "828080818eeebdd3018eeebdd52405fc",
    "828080818eeebdd3018eeebdd3cb00c1",
    "2c9c8594971a1f370197633abd8e052a",
    "2c9c8594971a1f370197633abc9204e8",
    "2c9c8594971a1f370197633abd09050c",
    "2c9c8594971a1f370197633abc0004c0",
    "2c9c8594971a1f370197633abf5205a4",
    "828080818eeebdd3018eeebdd545064d",
    "828080818eeebdd3018eeebdd5240624",
    "2c9c8594971a1f370197633abd2a0512",
    "828080818eeebdd3018eeebdd5240584",
    "828080818eeebdd3018eeebdd42500d2",
    "2c9c8594971a1f370197633abed3057a",
    "2c9c8594971a1f370197633abe6b055c",
    "828080818eeebdd3018eeebdd54506ab",
    "2c9c8594971a1f370197633abe540552",
    "828080818eeebdd3018eeebdd4260154",
    "2c9c8594971a1f370197633abe590554",
    "828080818eeebdd3018eeebdd52405c2",
    "828080818eeebdd3018eeebdd54506a5",
    "2c9c8594971a1f370197633abc6304dc",
    "2c9c8594971a1f370197633abdbf053a",
    "2c9c8594971a1f370197633abf140590",
    "828080818eeebdd3018eeebdd54506c2",
    "828080818eeebdd3018eeebdd425012b",
    "828080818eeebdd3018eeebdd52405bb",
    "828080818eeebdd3018eeebdd52405cc",
    "2c9c8594971a1f370197633abcc604fa",
    "2c9c8594971a1f370197633abc7b04e2",
    "2c9c8594971a1f370197633abd40051a",
    "2c9c8594971a1f370197633abc3d04d0",
    "2c9c8594971a1f370197633abc5104d6",
    "828080818eeebdd3018eeebdd5240625",
    "2c9c8594971a1f370197633abe190548",
    "828080818eeebdd3018eeebdd54506bf",
    "2c9c8594971a1f370197633abe0b0542",
    "2c9c8594971a1f370197633abcba04f6",
    "828080818eeebdd3018eeebdd52405b9",
    "828080818eeebdd3018eeebdd42500ec",
    "828080818eeebdd3018eeebdd52405b7",
    "2c9c8594971a1f370197633abdaf0534",
    "2c9c8594971a1f370197633abeeb0582",
    "2c9c8594971a1f370197633abca404ee",
    "2c9c8594971a1f370197633abe770560",
    "828080818eeebdd3018eeebdd54506b4",
    "828080818eeebdd3018eeebdd3cb00bd",
    "2c9c8594971a1f370197633abd660520",
    "828080818eeebdd3018eeebdd524059a",
    "828080818eeebdd3018eeebdd5450669",
    "2c9c8594971a1f370197633abea2056e",
    "2c9c8594971a1f370197633abc2104c8",
    "828080818eeebdd3018eeebdd5450671",
    "2c9c8594971a1f370197633abf2a0596",
    "2c9c8594971a1f370197633abeb70570",
    "2c9c8594971a1f370197633abd97052e",
    "828080818eeebdd3018eeebdd52405b3",
    "828080818eeebdd3018eeebdd54506ac",
    "2c9c8594971a1f370197633abe4b054e",
    "828080818eeebdd3018eeebdd52405e4",
    "2c9c8594971a1f370197633abcd70500",
    "828080818eeebdd3018eeebdd5450675",
    "828080818eeebdd3018eeebdd425010c",
    "828080818eeebdd3018eeebdd5240634",
    "2c9c8594971a1f370197633abeca0576",
    "828080818eeebdd3018eeebdd4250114",
    "2c9c8594971a1f370197633abc2d04cc",
    "828080818eeebdd3018eeebdd5240596",
    "828080818eeebdd3018eeebdd524057f",
    "828080818eeebdd3018eeebdd545066a",
    "828080818eeebdd3018eeebdd524063a",
    "2c9c8594971a1f370197633abf3d059c",
    "2c9c8594971a1f370197633abe620558",
    "2c9c8594971a1f370197633abd7a0526",
    "2c9c8594971a1f370197633abe7b0562",
    "2c9c8594971a1f370197633abcb504f4",
  ],
};

export default config;
